export default __webpack_public_path__ + "static/EnergyLabelAndPrice1_x2-1d5ed96ea0b565b0606aef705e4536d3.png";